'use client';

import React from 'react';
import DynamicTabs from '@components/DynamicTabs';
import WimbledonBridgeData from './WimbledonBridgeData';
import { Stack } from '@mui/material';
import cn from './style.module.scss';
export default function WimbledonBridgeSpecification(props: any) {
  const tabs = props.locale.section?.wimbledonBridgeSpecificationData?.map(
    (item: any) => ({
      title: item.tabButton,
      content: (
        <WimbledonBridgeData
          tabDescription={item.tabDescription as string}
          images={item.images}
          type={item.type || ''}
        />
      ),
    })
  );

  return (
    <Stack className={cn.wimbledonBridgeSpecification} component="section">
      <DynamicTabs
        tabs={tabs}
        layout="horizontal"
        moveDirection="fade"
        className={cn.wimbledonSpecificationBlock}
        elementClass={cn.wimbledonSpecificationElement}
        tabClass={cn.wimbledonSpecificationTab}
        listClassName={cn.wimbledonSpecificationList}
        itemClassName={cn.wimbledonSpecificationItem}
        linkClass={cn.wimbledonSpecificationLink}
        activeClassName={cn.wimbledonSpecificationActive}
        contentClass={cn.wimbledonSpecificationContent}
      />
    </Stack>
  );
}
